/**
 * Database type.
 */
export type DatabaseType =
    "mysql"|
    "postgres"|
    "cockroachdb"|
    "sap"|
    "mariadb"|
    "sqlite"|
    "cordova"|
    "react-native"|
    "nativescript" |
    "sqljs"|
    "oracle"|
    "mssql"|
    "mongodb"|
    "aurora-data-api"|
    "aurora-data-api-pg"|
    "expo"|
    "better-sqlite3" |
    "capacitor";
